import { Link } from "react-router-dom";
import { BTN } from "@/lib/design";

export default function NotFound() {
    return (
        <section className="min-h-[60vh] grid place-items-center bg-[#F7F5F0] px-6">
            <div className="max-w-lg text-center" data-testid="notfound-page">
                <p className="text-[12px] uppercase tracking-[0.2em] text-[#C8A24A] font-medium">
                    404
                </p>
                <h1 className="mt-3 font-[Outfit] text-4xl sm:text-5xl font-semibold tracking-tight">
                    Looks like this road's grown over.
                </h1>
                <p className="mt-5 text-[16px] text-[#6F6B63]">
                    The page you're looking for isn't here. Let's get you back on track.
                </p>
                <div className="mt-8 flex flex-wrap justify-center gap-3">
                    <Link to="/" className={BTN.primary} data-testid="notfound-home-cta">
                        Back to home
                    </Link>
                    <Link to="/contact" className={BTN.outline} data-testid="notfound-contact-cta">
                        Contact us
                    </Link>
                </div>
            </div>
        </section>
    );
}
